import React from 'react'
import PropTypes from 'prop-types'
import Modal from '../../organisms/Modal'
import PasswordHelpContent from './PasswordHelpContent'

export const PasswordHelpModalTemplate = ({ open, onClose }) => (
  <Modal open={open} onClose={onClose} transitionTime={250}>
    <PasswordHelpContent onOptionClick={onClose} />
  </Modal>
)

PasswordHelpModalTemplate.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}
